import {StyleSheet, View} from "react-native";
import {UserAvatar} from "@/lib/types";
import Avatar from "@/lib/components/Avatar";
import {ReactNode} from "react";

type Props = {
    avatars: UserAvatar[],
    children?: ReactNode,
}

export default function AvatarStack({avatars, children}: Props) {
    return (
        <View style={styles.avatars}>
            {avatars.slice(0, 4).map(avatar => (
                <View key={avatar.id} style={styles.avatar}>
                    <Avatar avatar={avatar}/>
                </View>
            ))}
            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    avatars: {
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 16,
    },
    avatar: {
        marginLeft: -16,
    }
})
